import React, {useEffect, useState} from "react";
import {Box, Button, Dialog, DialogContent, IconButton, Stack, Typography} from "@mui/material";
import questionType from "../assets/data/typeMap";
import {QuestionSwitch} from "./Questions/QuestionSwitch";
import {firestore} from "../firebase/clientApp";
import {useParams} from "react-router-dom";
import {Close} from "@mui/icons-material";
import pleshDark from "../theme/pleshDark";


export const PinnedQuestions = ({questions}) => {
  const [selected, setSelected] = useState('')
  const {eventOwnerId, id} = useParams()

  const [elementPlaying, setElementPlaying] = useState({})

  useEffect(() => {
    selected !== '' ? getElementPlaying() : setElementPlaying({})
  }, [selected]);

  function getElementPlaying() {
    firestore.collection(`users/${eventOwnerId}/events/${id}/queue`).doc(selected).onSnapshot(s => {
      setElementPlaying({...s.data(), id: s.id})
      return s.data()
    })
  }

  console.log("selected:", selected)
  console.log("elementPlaying:", elementPlaying)

  return (
    <Box mt={3}>
      {selected !== '' &&
        <Dialog open={selected !== ''} onClose={() => setSelected('')} maxWidth={'md'}
                fullWidth={true}
                fullScreen={elementPlaying.tipo === 'color'}
        >
          <DialogContent id={'a' + selected} /*id={'pinnedQuestionDialogBg'}*/>
            <Box sx={{textAlign: 'right'}}>
              <IconButton onClick={() => setSelected('')}
                          sx={{
                            color: elementPlaying.tipo === 'color' ? pleshDark.palette.getContrastText(elementPlaying.color) : ''
                          }}
              >
                <Close/>
              </IconButton>
            </Box>
            <Typography textAlign={'center'} variant={'h5'}
                        sx={{color: elementPlaying.tipo === 'text' ? '#000' : '#E32013', fontFamily:'JohnsonDisplay'}}
            >
              {elementPlaying.domanda}
            </Typography>
            <QuestionSwitch elementPlaying={elementPlaying}/>
          </DialogContent>
        </Dialog>}
      <Stack spacing={2}>
        {
          questions.docs?.length > 0 ?
            questions.docs?.sort((a, b) => a.data().position - b.data().position).map((q, i) => {
                return <Button key={i} variant={'home-question'} startIcon={questionType[q.data().tipo].icon}
                               sx={{
                                 background: q.data().tipo === 'color' ? q.data().color : '',
                                 color: q.data().tipo === 'color' ? pleshDark.palette.getContrastText(q.data().color) : ''
                               }}
                               onClick={() => setSelected(q.id)}>
                  {q.data().domanda}
                </Button>
              }
            )
            :
              <Typography textAlign={'center'} pl={2} fontSize={'1.2rem'}>
                Attendi qui, <br/>
                la prossima interazione inizierà a breve!
              </Typography>
        }
      </Stack>
    </Box>
  )
}